<template>
  <div>
    <div
      @click="resetOrientations"
      :class="{ '-active': hasOrientationsSelected }"
      class="-reset -reset-filter"
    >
      Reset
    </div>
    <div class="wt2-filter-orientation">
      <div
        class="-orientation"
        v-for="(o, i) in orientationOptions"
        :key="i"
        @click="orientationChanged(o)"
        :class="{ selected: isOrientationSelected(o) }"
      >
        <div class="-box" :class="o.className"></div>
        {{ o.label }}
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  data() {
    return {
      orientationOptions: [
        {
          label: 'Wide',
          className: 'horizontal',
          id: 'LANDSCAPE',
        },
        {
          label: 'Vertical',
          className: 'vertical',
          id: 'PORTRAIT',
        },
        {
          label: 'Square',
          className: 'square',
          id: 'SQUARE',
        },
      ],
    };
  },

  analytics: {
    filterByOrientation: 'Filter By Orientation',
  },

  computed: Object.assign(
    {
      hasOrientationsSelected() {
        const orientations = this.contextFilters.orientation;
        return _.isDefined(orientations) && orientations.length;
      },
    },
    app.Vuex.mapGetters(['contextFilters'])
  ),

  props: {},

  methods: Object.assign(
    {
      resetOrientations(e) {
        if (e) {
          e.stopPropagation();
        }
        this.SET_ORIENTATIONS_SELECTION({ orientation: [] });
        this.sendEvent();
        this.$emit('search');
      },

      isOrientationSelected(o) {
        const orientations = this.contextFilters.orientation;
        return orientations && orientations.includes(o.id);
      },

      orientationChanged(o) {
        const clonedOrientations = this.contextFilters.orientation.slice(0);
        const odIndex = clonedOrientations.indexOf(o.id);
        if (odIndex > -1) {
          clonedOrientations.splice(odIndex, 1);
        } else {
          clonedOrientations.push(o.id);
        }

        this.SET_ORIENTATIONS_SELECTION({ orientation: clonedOrientations });
        this.sendEvent();
        this.$emit('search');
      },

      sendEvent() {
        const payload = {};
        const allOrientations = _.map(this.orientationOptions, (o) => o.id);
        const selectedOrientations = _.map(this.contextFilters.orientation);
        payload.ANY = !_.isEmpty(selectedOrientations);
        for (const o of allOrientations) {
          payload[o] = selectedOrientations.includes(o);
        }
        this.$triggerAnalytics('filterByOrientation', payload);
      },
    },
    app.Vuex.mapActions(['SET_ORIENTATIONS_SELECTION'])
  ),
};
</script>
